import { render, staticRenderFns } from "./PausarOrden.vue?vue&type=template&id=54dae94c"
import script from "./PausarOrden.vue?vue&type=script&lang=js"
export * from "./PausarOrden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports